import type { ComponentProps } from 'react';
import React from 'react';
import { useResponsive } from '../../../hooks';
import { HorizontalScrollRail } from '../../HorizontalScrollRail';

// ────────────────────────────────────────────────────────────────────

export const CollectionsRailBase = (props: CollectionsRailBaseProps) => {
  const { headerText, footerText, children, ...restProps } = props;

  const { minWidth } = useResponsive();

  return (
    <HorizontalScrollRail
      heading={headerText}
      footerText={footerText}
      showNavControls={minWidth.isSM}
      gap={0}
      itemVisiblePercentThreshold={30}
      {...restProps}
    >
      {children as readonly React.ReactNode[]}
    </HorizontalScrollRail>
  );
};

// ─── TYPES ─────────────────────────────────────────────────────────────────

export type CollectionsRailBaseProps = {
  readonly headerText: string;
  readonly footerText?: string;
} & Partial<ComponentProps<typeof HorizontalScrollRail>>;
